import dayjs, { Dayjs } from "dayjs";

export type ReportShift = "morning" | "night" | "evening" | "daily" | string;

export const getReportShiftRange = (
  shift: ReportShift,
  referenceDate: Dayjs = dayjs(),
): { start: Dayjs; end: Dayjs } => {
  const day = referenceDate.startOf("day");

  switch (shift) {
    case "night":
      return {
        start: day,
        end: day.hour(8),
      };
    case "morning":
      return {
        start: day.hour(8),
        end: day.hour(16),
      };
    case "evening":
      return {
        start: day.hour(16),
        end: day.hour(23).minute(59).second(59),
      };
    case "daily":
    default:
      return {
        start: day,
        end: day.hour(23).minute(59).second(59),
      };
  }
};
